import * as yup from 'yup';

export const initialValues = {
	fullname: '',
	cpf: '',
	phone: [''],
	email: '',
	birthdate: '',
	gender: '',
	genderOther: '',
};

const schema = 
	yup.object().shape({
		fullname: yup
			.string()
			.matches(/\b[A-Za-zÀ-ú][A-Za-zÀ-ú]+,?\s[A-Za-zÀ-ú][A-Za-zÀ-ú]{2,19}\b/gi, { message: 'Preencha o nome completo' })
			.required('Nome é obrigatório!'),
		phone: yup
			.array()
			.min(1, 'Telefone é obrigatório!')
			.of(
				yup
					.string()
					.notRequired()
					.matches(/([0-9]{4,5}-[0-9]{4})/, { message: 'Telefone inválido!', excludeEmptyString: true }),
			)
			.test('testEmpty', 'Telefone é obrigatório!', val => {
				let hasOneValid = false;
				if (val.length > 0) {
					val.forEach(phone => {
						if (phone != null && !['', '(__) ____-____', '(__) _____-____'].includes(phone)) {
							hasOneValid = true;
						}
					});
				}
				return hasOneValid;
			}),
		birthdate: yup.string().matches(/([0-9]{2}\/[0-9]{2}\/[0-9]{4})/, {message:'Data de nascimento é obrigatória!', excludeEmptyString:true}).required('Data de nascimento é obrigatória!'),
		gender: yup.string().required('Gênero é obrigatório!'),
		genderOther: yup.string(),
	});

export default schema;
